export const DisplayPage = {
  Queue: 'QUEUE',
  TicketPanel: 'TICKET_PANEL',
};
